import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-dark text-primary text-center py-3 mt-4">
      {/* <p>&copy; 2025 My Project Footer</p> */}
    </footer>
  );
};

export default Footer;
